import React, { useEffect, useState } from 'react'
import cholaLogo from '../Images/Cholamandalam_logo.svg'
import CholaDarkLogo from '../Images/chola_logo.svg'
import Lang from '../Images/lang-dark.svg'
import { useFormik } from 'formik';
import * as Yup from "yup";
import { useNavigate } from 'react-router';
import axios from 'axios';
import { useDispatch, useSelector } from 'react-redux';
import { setLoggedIn, setLosId, setMobileNo, setOtpTriggered, setPartner, setShowLanguage, setmandateID } from './MandateSlice';
import Loader from './Loader';
import { useSnackbar } from 'notistack';
import MainImg from '../Images/intro-img.svg'
import pdf from '../Live-Banks-in-API-E-Mandate.pdf'

function Login() {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const { enqueueSnackbar } = useSnackbar()
    const [showErr, setShowErr] = useState(false)
    const { mandateID, otpTriggered, userType } = useSelector((state) => state.mandateInfo);
    const [loader, setLoader] = useState(false)
    const initialValue = { losId: '', mobileNo: '' }
    const schema = Yup.object().shape({
        losId: Yup.string()
            .required("LOS ID / Agreement number is required")
            .matches(/^[a-zA-Z0-9]*$/, "Only number and text is allowed in LOS ID / Agreement number"),
        mobileNo: Yup.string()
            .required('Mobile number is required')
            .test("Mobile number length", "Mobile Number Must be exactly 10 numbers", (val) => {
                if (!val) return false;
                if (val.toString().length < 10) {
                    return false;
                }
                return true;
            }),
    })
    const formik = useFormik({
        initialValues: initialValue,
        validationSchema: schema,
        onSubmit: async (values) => { otpTrigger(values) }
    })
    const otpTrigger = (values) => {
        setShowErr(false)
        dispatch(setMobileNo(values?.mobileNo))
        dispatch(setLosId(values?.losId))
        setLoader(true)
        axios({
            url: process.env.REACT_APP_API_COMMON + 'mandate/otp',
            method: 'post',
            headers: {
                "Access-Control-Allow-Origin": "*",
                'Authorization': 'Bearer ' + process.env.REACT_APP_API_KEY
            },
            data: {
                "mobile": values?.mobileNo.toString(),
                "application_id": values?.losId,
                'sourcesys': userType.toUpperCase()
            }
        }).then((res) => {
            setLoader(false)
            if (res?.data?.message === "OTP generated successfully") {
                dispatch(setOtpTriggered(true))
                dispatch(setmandateID(res?.data?.unique_id))
                navigate('/otp')
            }
            else if(res?.data?.unique_id){
                dispatch(setmandateID(res?.data?.unique_id))
                sessionStorage.setItem("id", res?.data?.unique_id)
                sessionStorage.removeItem("partner");
                dispatch(setLoggedIn(true))
                dispatch(setPartner(res?.data?.sourcesys))
                navigate('/payment')
            }
            else {
                // enqueueSnackbar(res?.data?.Message, {
                //     variant: "error",
                //     preventDuplicate: true,
                //     autoHideDuration: 3000,
                // });
                setShowErr(res?.data?.Message)
            }
        }).catch((e) => {
            setLoader(false)
            setShowErr(e?.message)
          });
    }
    useEffect(()=>{
        dispatch(setOtpTriggered(false))
    },[])
    const handleSubmit = event => {
        event.preventDefault();
        formik.handleSubmit()
    };
    return (
        <>
            {loader && <Loader />}
            <form onSubmit={handleSubmit}>
                {/* <div class="Banner">
                    <div class="container Payment-way-page">
                        <div class="row">
                            <div class="col-12">
                                <a href="#" class="Lang" onClick={()=>{dispatch(setShowLanguage(true))}}><img src={Lang} /></a>
                                <div class="text-center brand">
                                    <img src={cholaLogo} class="img-fluid mb-2" />
                                    <p class="fw-semibold mb-5">Cholamandalam Investment and Finance Ltd</p>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12 p-0">
                                <div class="contBg">
                                    {showErr && <div class="alert alert-danger alert-dismissible fade show" role="alert">
                                        {showErr}
                                        <button type="button" class="btn-close" data-bs-dismiss="alert" onClick={()=>{setShowErr(false)}} aria-label="Close">x</button>
                                    </div>}
                                    <h3 class="mt-2 mb-1">Welcome to <span class="text-danger">Mandate</span></h3>
                                    <p class="text-secondary">Please enter the <span class="fw-medium">User ID & Phone No.</span></p>
                                    <div class="form-floating mb-3">
                                        <input type="text" className={"form-control " + ((formik.errors.losId && formik.touched.losId) ? "is-invalid" : "")} onBlur={formik.handleBlur} id="floatingInput1" name="losId" onChange={formik.handleChange} value={formik.values.losId} placeholder="Enter LOS ID" />
                                        <label for="floatingInput">LOS ID</label>
                                        <div className="invalid-feedback">
                                            {formik.errors.losId && formik.touched.losId
                                                ? formik.errors.losId
                                                : ''}
                                        </div>
                                    </div>
                                    <div class="form-floating mb-3">
                                        <input type="number" className={"form-control " + ((formik.errors.mobileNo && formik.touched.mobileNo) ? "is-invalid" : "")} onBlur={formik.handleBlur} id="floatingInput3" name="mobileNo" onChange={formik.handleChange} value={formik.values.mobileNo} placeholder="Enter Phone No" />
                                        <label for="floatingInput">Phone No.</label>
                                        <div className="invalid-feedback">
                                            {formik.errors.mobileNo && formik.touched.mobileNo
                                                ? formik.errors.mobileNo
                                                : ''}
                                        </div>
                                    </div>
                                    <div class="mb-3">
                                        <button class="btn Proceed_btn w-100" type="submit button">Proceed</button>
                                    </div>
                                    <div class="text-center"> <a href="#" target="_blank" class="fw-medium">eNACH Eligible Banks</a></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> */}
                <div class="IndBg">
                    <div class="bd-spacer">
                        <div class="container">
                            <div class="row">
                                <div class="col-lg-7 text-center">
                                    <h1 class="mb-3 d-lg-block d-md-none d-sm-none d-none">E - Nach<br /> Registration</h1>
                                    <h1 class="mt-4 mb-1 d-lg-none d-md-block d-sm-block">E - Nach Registration</h1>
                                    <img src={MainImg} class="logImg img-fluid" />
                                </div>
                                <div class="col-lg-5 col-sm-12 col-md-12">
                                    <div class="LogBox">
                                        {showErr &&
                                            <div class="alert alert-danger alert-dismissible fade show" role="alert">
                                                <p class="mb-1">{showErr}</p>
                                                <button type="button" class="btn-close" data-bs-dismiss="alert" onClick={() => { setShowErr(false) }} aria-label="Close">&#215;</button>
                                            </div>
                                        }
                                        {/* <div class="alert alert-danger alert-dismissible fade show" role="alert">
                                        <p class="mb-1">Entered LOS ID or Mobile Number is not registered with CIFCL LAP.</p>
                                        <p class="mb-0">Please re-try by entering the correct information (or) contact your nearest branch for
                                            more details</p>
                                        <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close">&#215;</button>
                                    </div> */}
                                        <h3 class="mb-5">Welcome to <span class="text-danger">E-Nach</span> Registration</h3>
                                        <div class="form-floating mb-3">
                                            <input type="text" className={"form-control " + ((formik.errors.losId && formik.touched.losId) ? "is-invalid" : "")} onBlur={formik.handleBlur} id="floatingInput1" name="losId" onChange={formik.handleChange} value={formik.values.losId} placeholder="Enter LOS ID/Agreement Number" />
                                            <label for="floatingInput">LOS ID/Agreement Number</label>
                                            <div className="invalid-feedback">
                                                {formik.errors.losId && formik.touched.losId
                                                    ? formik.errors.losId
                                                    : ''}
                                            </div>
                                        </div>
                                        <div class="form-floating mb-3">
                                            <input type="number" className={"form-control " + ((formik.errors.mobileNo && formik.touched.mobileNo) ? "is-invalid" : "")} onBlur={formik.handleBlur} id="floatingInput3" name="mobileNo" onChange={formik.handleChange} value={formik.values.mobileNo} placeholder="Enter Mobile No" />
                                            <label for="floatingInput">Phone No.</label>
                                            <div className="invalid-feedback">
                                                {formik.errors.mobileNo && formik.touched.mobileNo
                                                    ? formik.errors.mobileNo
                                                    : ''}
                                            </div>
                                        </div>
                                        <div class="mb-3">
                                            <button class="btn Proceed_btn w-100" type="submit button">Proceed</button>
                                        </div>
                                        {/* <div class="text-center"> <a href={pdf} class="fw-medium">eNACH Eligible Banks</a></div> */}
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <nav class="navbar MenuTop fixed-top navbar-expand-lg">
                                        <div class="container d-flex">
                                            <a class="navbar-brand p-0 me-0">
                                                <img src={CholaDarkLogo} alt="Chola Logo" />
                                            </a>
                                            <ul class="navbar-nav">
                                                <li class="nav-item">
                                                    {/* <a class="nav-link" onClick={() => { dispatch(setShowLanguage(true)) }}>
                                                    <img src={Lang} />
                                                </a> */}
                                                </li>
                                            </ul>
                                        </div>
                                    </nav>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </>
    )
}

export default Login